class Events {
  static _instance = null
  _handlers = {}
  _autoIncrementId = 1

  constructor() {
    if (Events._instance) return Events._instance
    Events._instance = this
  }

  static getInstance() {
    return new Events()
  }

  dispatch(eventName, data = {}) {
    const event = new CustomEvent(eventName, { detail: data })
    document.dispatchEvent(event)
  }

  handle(eventName, callback, id = null) {
    const handlerId =
      id || `${eventName}----${Date.now()}-${this._autoIncrementId++}`
    const handler = e => callback(e.detail)

    this._handlers[handlerId] = { eventName, handler }
    document.addEventListener(eventName, handler)

    return handlerId
  }

  removeHandler(handlerId) {
    const record = this._handlers[handlerId]
    if (!record) return

    document.removeEventListener(record.eventName, record.handler)
    delete this._handlers[handlerId]
  }
}

export default Events
